<template>
  <div 
    class="skeleton-icon"
    :class="{ 'rounded-circle': circle, 'rounded': !circle }"
    :style="{ width: size, height: size }"
  ></div>
</template>

<script>
export default {
  name: 'SkeletonIcon',
  props: {
    size: {
      type: String,
      default: '42px'
    },
    circle: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.skeleton-icon {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  flex-shrink: 0;
}

.skeleton-icon.rounded {
  border-radius: 8px;
}

.skeleton-icon.rounded-circle {
  border-radius: 50%;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
